<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      id="myOrderAdd"
      :modal="false"
      @close="htmlDataDialogClose"
      width="100%"
    >
      <!-- 采购收货 详情 -->
      <purchaseStorageAdd
        v-if="dialogVisible && homeIndex == 16"
        :routeType="routeType"
        :routeQuery="routeQuery"
        @backHome="backHome"
      ></purchaseStorageAdd>
      <!-- 新增产品委外退料 -->
      <outsourcingProductReturnAdd
        v-if="dialogVisible && homeIndex == 49"
        :routeType="routeType"
        :routeQuery="routeQuery"
        @backHome="backHome"
      >
      </outsourcingProductReturnAdd>
      <!-- 新增产品委外发货 -->
      <finishAdd
        v-if="dialogVisible && homeIndex == 50"
        :routeType="routeType"
        :routeQuery="routeQuery"
        @backHome="backHome"
      >
      </finishAdd>
      <!-- 新增工序委外发货 -->
      <outsourcingProcessesFinishAdd
        v-if="dialogVisible && homeIndex == 172"
        :routeType="routeType"
        :routeQuery="routeQuery"
        @backHome="backHome"
      >
      </outsourcingProcessesFinishAdd>
    </el-dialog>
    <!-- 需要的参数必须添加 -->
    <myOrderDetails
      v-if="detailsVisible"
      :visible="detailsVisible"
      :homeIndex="homeIndex"
      :routeType="routeType"
      :routeQuery="routeQuery"
      :modelType="modelType"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderDetails>
  </div>
</template>
<script>
import purchaseStorageAdd from "@/views/purchase/components/storage_add.vue";
import outsourcingProductReturnAdd from "@/views/outsourcingProduct/components/return_add.vue";
import finishAdd from "@/views/outsourcingProduct/components/finish_add.vue";
import outsourcingProcessesFinishAdd from "@/views/outsourcingProcesses/components/finish_add.vue";
export default {
  components: {
    purchaseStorageAdd,
    outsourcingProductReturnAdd,
    finishAdd,
    outsourcingProcessesFinishAdd,
  },
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    homeIndex: {
      type: Number,
      default: false,
    },
    // 是否弹出
    visible: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("dialogVisible", val);
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      detailsVisible: false,
    };
  },
  methods: {
    htmlDataDialogClose() {
      this.dialogVisible = false;
      this.detailsVisible = false;
      this.$emit("htmlDataDialogClose");
    },
    async backHome(state, data) {
      if (!state) {
        this.dialogVisible = false;
      }
      switch (await state) {
        //
        case 16:
          this.routeQuery = await data;
          this.detailsVisible = await true;
          break;
        // 产品委外退料
        case 49:
          this.routeQuery = await data;
          this.detailsVisible = await true;
          break;
        // 产品委外发货
        case 50:
          this.routeQuery = await data;
          this.detailsVisible = await true;
          break;
        // 工序委外发货
        case 172:
          this.routeQuery = await data;
          this.detailsVisible = await true;
          break;
        default:
          break;
      }
      this.$emit("backHome");
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 8px !important;
  padding-top: 0px !important;
}
::v-deep .el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}
::v-deep .el-dialog > .el-dialog__header > .el-dialog__headerbtn {
  display: none;
}
</style>
